export const algorithmData = [
    {
        displayName: "Prisoner Box Riddle",
        link: "https://github.com/MrMicrowaveOven/prisoner-box-riddle",
        description: "A simulation of the solution to the Prisoner Box Riddle",
    },
    {
        displayName: "Alien Communique",
        link: "https://github.com/MrMicrowaveOven/AlienCommunique",
        description: "Our solution to the Alien Communique problem, Spring 2016",
    },
    {
        displayName: "Clock Hands Riddle",
        link: "https://github.com/MrMicrowaveOven/clock_hands_riddle",
        description: "When do the hands of a clock cross each other?",
    },

]